// import PropTypes from '../_util/vue-types';
import { provide, reactive } from 'vue';
export var injectExtraPropsKey = Symbol();
var FunctionProvider = {
  inheritAttrs: false,
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        attrs = _ref.attrs;
    provide(injectExtraPropsKey, reactive(attrs));
    return function () {
      var _a;

      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
    };
  }
};
export default FunctionProvider;